import React from "react";
import { MagnifyingGlass, MapPin, X } from "@phosphor-icons/react";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

export const FilterBar = ({
  meta,
  filters,
  setFilters,
  nearbyActive,
  onToggleNearby,
  resultCount,
}) => {
  const update = (key, value) => setFilters((f) => ({ ...f, [key]: value }));

  return (
    <div
      data-testid="filter-bar"
      className="sticky top-[73px] z-30 border-b border-white/10 bg-[#0B0D17]/85 backdrop-blur-xl"
    >
      <div className="mx-auto flex max-w-7xl flex-col gap-4 px-5 py-5 sm:px-8 lg:flex-row lg:items-center">
        <div className="relative flex-1">
          <MagnifyingGlass
            size={18}
            className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-slate-500"
          />
          <Input
            data-testid="search-input"
            value={filters.search}
            onChange={(e) => update("search", e.target.value)}
            placeholder="Search shows, cities, keywords…"
            className="h-11 rounded-full border-white/10 bg-white/[0.04] pl-11 text-white placeholder:text-slate-500 focus-visible:ring-blue-500"
          />
        </div>

        <div className="flex flex-wrap items-center gap-3">
          <Select value={filters.country} onValueChange={(v) => update("country", v)}>
            <SelectTrigger
              data-testid="country-filter"
              className="h-11 w-[170px] rounded-full border-white/10 bg-white/[0.04] text-white focus:ring-blue-500"
            >
              <SelectValue placeholder="Country" />
            </SelectTrigger>
            <SelectContent className="border-white/10 bg-[#12141F] text-white">
              <SelectItem value="all">All Countries</SelectItem>
              {(meta.countries || []).map((c) => (
                <SelectItem key={c} value={c}>{c}</SelectItem>
              ))}
            </SelectContent>
          </Select>

          <Select value={filters.category} onValueChange={(v) => update("category", v)}>
            <SelectTrigger
              data-testid="category-filter"
              className="h-11 w-[180px] rounded-full border-white/10 bg-white/[0.04] text-white focus:ring-blue-500"
            >
              <SelectValue placeholder="Category" />
            </SelectTrigger>
            <SelectContent className="border-white/10 bg-[#12141F] text-white">
              <SelectItem value="all">All Categories</SelectItem>
              {(meta.categories || []).map((c) => (
                <SelectItem key={c} value={c}>{c}</SelectItem>
              ))}
            </SelectContent>
          </Select>

          <button
            data-testid="nearby-toggle"
            onClick={onToggleNearby}
            className={`inline-flex h-11 items-center gap-2 rounded-full border px-5 text-sm font-semibold transition-colors duration-200 ${
              nearbyActive
                ? "border-blue-500 bg-blue-500/15 text-blue-300"
                : "border-white/10 bg-white/[0.04] text-slate-300 hover:border-white/25 hover:text-white"
            }`}
          >
            {nearbyActive ? <X size={16} /> : <MapPin size={16} weight="fill" />}
            {nearbyActive ? "Clear Nearby" : "Shows Nearby"}
          </button>
        </div>
      </div>
      <div className="mx-auto max-w-7xl px-5 pb-3 sm:px-8">
        <p data-testid="result-count" className="text-xs uppercase tracking-wider text-slate-500">
          {resultCount} show{resultCount === 1 ? "" : "s"} found
          {nearbyActive ? " · sorted by distance" : ""}
        </p>
      </div>
    </div>
  );
};
